import React, { useEffect, useState } from "react";
import { Building2, Trophy } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { getIcon } from "@/lib/icons";
import api from "@/lib/api";

function Card({ a }) {
  const Icon = getIcon(a.icon);
  return (
    <div className="glass card-hover rounded-2xl p-7 h-full flex items-start gap-4" data-testid={`achievement-${a.id}`}>
      <div className="w-12 h-12 rounded-xl flex items-center justify-center shrink-0" style={{ background: "rgba(var(--primary-rgb),0.12)" }}>
        <Icon className="text-primary-c" size={24} />
      </div>
      <div>
        <h3 className="font-display font-bold text-lg text-t">{a.title}</h3>
        <p className="text-muted-c text-sm mt-1.5">{a.description}</p>
      </div>
    </div>
  );
}

export default function Achievements() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/achievements").then(({ data }) => setItems(data)).catch(() => {}); }, []);

  const institute = items.filter((a) => (a.category || "").toLowerCase() === "institute");
  const learner = items.filter((a) => (a.category || "").toLowerCase() === "learner");

  return (
    <div className="relative z-10 pt-28">
      <section className="mx-auto max-w-7xl px-5 py-12">
        <Reveal>
          <span className="text-xs uppercase tracking-[0.25em] font-semibold text-primary-c">Achievements</span>
          <h1 className="font-display font-black text-5xl sm:text-6xl tracking-tighter text-t mt-4">Milestones &amp; <span className="text-primary-c">Proud Moments.</span></h1>
          <p className="text-muted-c text-lg mt-5 max-w-2xl">Every certificate, placement and win is a story we're proud of.</p>
        </Reveal>

        <Reveal delay={0.05}><h2 className="font-display font-bold text-3xl text-t mt-14 mb-6 flex items-center gap-3"><Building2 className="text-primary-c" size={24} /> Institute Achievements</h2></Reveal>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {institute.map((a, i) => <Reveal key={a.id} delay={(i % 3) * 0.08}><Card a={a} /></Reveal>)}
          {institute.length === 0 && <div className="glass rounded-2xl p-10 text-center text-muted-c col-span-full">Coming soon.</div>}
        </div>

        <Reveal><h2 className="font-display font-bold text-3xl text-t mt-16 mb-6 flex items-center gap-3"><Trophy className="text-primary-c" size={24} /> Learner Achievements</h2></Reveal>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {learner.map((a, i) => <Reveal key={a.id} delay={(i % 3) * 0.08}><Card a={a} /></Reveal>)}
          {learner.length === 0 && <div className="glass rounded-2xl p-10 text-center text-muted-c col-span-full">Coming soon.</div>}
        </div>
      </section>
    </div>
  );
}
